/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from "react";
import copyIcon from "../../Assets/img/copy_Image.png";

import {
  ClientPlatformCode,
  DealCouponFreqData,
  DefaultCardName,
  FormatDate,
  trackEvent,
  UserIdAndStatusData,
  UtilityReducer,
  ValidateLoginToken,
} from "../../Utility/Utility";
import { useDispatch, useSelector } from "react-redux";
import { decryptAES } from "../../Common/Axios/encrypt";
import getTranslation from "../../TranslationUtility/TranslationUtility";
import { Link, useLocation } from "react-router-dom";
import ScrollToTop from "../../Utility/ScrollToTop/ScrollToTop";
import WebTermsCondition from "../WebTermsCondition/WebTermsCondition";
import { GetOfferData } from "../../Store/Slices/dealsDataSlice";
import { dataFromDealPage } from "../../Store/Slices/utilityReducer.js";
import { onLandingHome } from "../../Store/Slices/homePageLandingSlice.js";
import Loader from "../../Utility/Loader/Loader.js";

const CouponModal = ({ onCouponClose }) => {
  const location = useLocation();
  const dispatch = useDispatch();
  const { clientCode: clientPlatformCode, platformCode } = ClientPlatformCode();
  const { userId, userStatus } = UserIdAndStatusData();
  const defaultCardName = DefaultCardName();
  const token = ValidateLoginToken();
  const login = sessionStorage.getItem("login");
  const loginAuthData = useSelector((state) => state.loginAuthReducer);
  const cards = UtilityReducer();
  const creditCards = cards?.creditCards;
  const queryParams = new URLSearchParams(location.search);
  const did = queryParams.get("did")?.replace(/\s/g, "+");
  const dealId = did && decryptAES(did);
  const pathnames = location.pathname.split("/").filter((x) => x);
  const { dealCoupounFrequencies } = useSelector((state) => state?.dealsDataSlice?.allofferData);
  const { dealCouponFreqData } = DealCouponFreqData();
  const dataFromDealPageData = useSelector((state) => state?.utilityReducer?.dataFromDealPage);
  const couponData = dataFromDealPageData?.dealCouponData || [];
  const dealImage = dataFromDealPageData?.dealData || {};
  const dealCoupounFrequenciesList = [...(dealCouponFreqData ?? []), ...(dealCoupounFrequencies ?? [])];
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isExpanded, setIsExpanded] = useState(0);
  const translation = getTranslation();
  const [copied, setCopied] = useState(null);
  const [coupon, setCoupon] = useState(null);
  const [about, setAbout] = useState(false);
  const handleClick = (params, couponData) => {
    setIsModalOpen(true);
    if (params === "terms") {
      setAbout(false);
      setCoupon(couponData);
    } else {
      setAbout(true);
    }
  };

 useEffect(() => {
   if (couponData?.length === 0) {
     if (token?.memberIdentifier || loginAuthData?.data || !loginAuthData) {
       const cards = [...new Set(creditCards?.map(card => card.Network?.toLowerCase()).filter(Boolean))] || [];
       const cardCodeValue = [
         ...new Set(
           token?.otherListAttribute?.[0]?.valueDetails
             ?.filter(card => card.status === "1" || card.status === "2")
             ?.map(card => card.CardTypeName?.toLowerCase())
             .filter(Boolean)
         )
       ] || [];
       const initialFilters = {
         validity: [],
         category: [],
         brand: [],
         offer: [],
       };
       let payload = {
         search: "",
         filters: initialFilters,
       };

       if (token?.memberIdentifier) payload.memberIdentifier = token.memberIdentifier;
       if (token?.memberIdentifier && cards.length > 0) payload.cardsNetwork = cards;
       if (token?.memberIdentifier && token?.otherListAttribute[0]?.valueDetails?.length > 0) payload.cardCodeValue = cardCodeValue;
       dispatch(onLandingHome());
       dispatch(GetOfferData(payload)).then((response) => {
         const newDeals = response?.payload?.data?.response?.items[0]?.deals || [];
         const newCoupons = response?.payload?.data?.response?.items[0]?.dealCoupouns || [];
         const deal = newDeals?.find(
           (coupon) => coupon?.id === dealId
         );
         const dealCoupons = newCoupons?.filter(
           (coupon) => coupon?.dealId === dealId
         );
         dispatch(dataFromDealPage({
           dealData: deal,
           dealCouponData: dealCoupons
         }));
       });
     }
   }
    // eslint-disable-next-line
  }, []);

  // to handle copy coupon code
  const handleCopy = (coupon) => {
    let couponCode = "";
    if (coupon?.typeOfCoupoun === translation?.static) {
      couponCode = coupon?.coupounCode;
    } else if (coupon?.typeOfCoupoun === translation?.dynamic) {
      const dynamicCouponCode = dealCoupounFrequenciesList.find(
        (deal) => deal.dealCoupounId === coupon.id && deal?.status === "Active"
      );
      couponCode = decryptAES(dynamicCouponCode?.coupounCode);
    }
    if (couponCode) {
      navigator.clipboard.writeText(couponCode);
      setCopied(coupon.id);
      setTimeout(() => {
        setCopied(null);
      }, 3000);
    }
  };

  // Prevent background scroll when Terms/About modal is open.
  useEffect(() => {
    const previousOverflow = document.body.style.overflow;
    document.body.style.overflow = isModalOpen ? "hidden" : previousOverflow || "";

    return () => {
      document.body.style.overflow = previousOverflow || "";
    };
  }, [isModalOpen]);

  //to get coupon code from deal coupon based on couponId and dealId
  const getCouponCodeFromCoupon = (coupon) => {
    const couponCode = coupon?.coupounCode;

    return couponCode;
  };

  let sortedData = [
    ...couponData?.filter((item) => item.source?.toLowerCase() === "bank"),
    ...couponData?.filter((item) => item.source?.toLowerCase() !== "bank"),
  ];

  sortedData = sortedData.sort((a, b) => {
    // If both have displayOrder, sort numerically ascending
    if (a.displayOrder != null && b.displayOrder != null) {
      return a.displayOrder - b.displayOrder;
    }
    // If only a has displayOrder, a comes first
    if (a.displayOrder != null) {
      return -1;
    }
    // If only b has displayOrder, b comes first
    if (b.displayOrder != null) {
      return 1;
    }
    // If neither has displayOrder, maintain original order
    return 0;
  });

  const handleClaimNow = (couponData) => {
    trackEvent("coupon_redeem_click", {
      image_url: `${process.env.REACT_APP_CLIENT_IMAGE_URL}${dealImage?.commonImage}`,
      title: couponData?.title,
      brand_name: dealImage?.name,
      page_type: location?.pathname === "/" ? "home_page" : "offers_page",
      page_url: couponData?.cta,
      section_title: "NA",
      client_code: clientPlatformCode,
      platform_code: platformCode,
      user_id: userId,
      user_status: userStatus,
      card_name: defaultCardName
    });
    if(couponData?.isStaccOffer === true) {
      window.open(couponData?.cta, "_self");
    } else {
      window.open(couponData?.cta, "_blank");
    }
  };

  return (
    <>
      <ScrollToTop />
      {!dealImage?.name ? <Loader /> :
      <div className="mt-6 px-4">
        <div className="bg-white rounded-lg web-coupon-modal mx-auto">
          <div className="py-4 flex justify-between items-center">
            <div className="flex flex-col space-y-4">
              <span className="option-head flex">
                {" "}
                <Link to="/" className="flex">
                  {translation?.home}
                  <div className="breadcrumb">
                    {pathnames.length > 0 &&
                      pathnames.map((name, index) => {
                        const routeTo = `/${pathnames
                          .slice(0, index + 1)
                          .join("/")}`;
                        return (
                          <span key={index}>
                            <span className="breadcrumb-separator"> / </span>
                            <Link to={routeTo === '/Offers' ? '/deal' : routeTo} className="breadcrumb-link">
                              {name.charAt(0).toUpperCase() + name.slice(1)}
                            </Link>
                          </span>
                        );
                      })}
                  </div>
                </Link>
                / {dealImage?.name}
              </span>
              <div className="flex items-center space-x-2">
                <img
                  src={`${process.env.REACT_APP_CLIENT_IMAGE_URL}${dealImage?.commonImage}`}
                  alt={dealImage?.name}
                  title={dealImage?.name}
                  className="img-sz-h"
                />
                <h2 className="text-xl font-bold text-gray-800">
                  {dealImage?.name}
                </h2>
              </div>
            </div>
          </div>

          {sortedData?.map((couponData, index) => {
            const expiryDate = dealCoupounFrequenciesList?.find(
              (code) => code?.dealCoupounId === couponData?.id
            )?.validUpto;
            return (
              <div key={index} className="coupon-card mb-8">
                <div className="relative">
                  <div className="coupon-card-header rounded-xl inset-4 flex flex-col p-2">
                    <span className="span-head text-center pt-4 mb-5">
                      {couponData.title}
                    </span>
                    {couponData?.typeOfCoupoun !== "NoCode" && (
                      <div className="left-1/2 transform -translate-x-1/2 w-5/6 p-1 coupon-code-field coupon-code-sz mt-4">
                        {copied === couponData.id && (
                          <div className=" absolute top-[-2rem] left-1/2 transform -translate-x-1/2 bg-green-500 text-white px-4 py-2 rounded-lg shadow-lg z-50 whitespace-nowrap">
                            {translation?.copiedSuccessfully}
                          </div>
                        )}
                        <div>
                          <input
                            type="text"
                            value={getCouponCodeFromCoupon(couponData)}
                            className="w-full bg-transparent custom-coupon-heading"
                            readOnly
                          />
                          <button
                            className="right-0 copy-icon"
                            onClick={() => handleCopy(couponData)}
                          >
                            <img
                              src={copyIcon}
                              alt="Copy Icon"
                              className="h-5 w-5"
                            />
                          </button>
                        </div>
                      </div>
                    )}
                  </div>
                </div>

                <div className="mx-3">
                  <div className="span-expiry-d mb-6 pl-2">
                    {translation?.expiryDate}: {FormatDate(expiryDate)}
                  </div>
                  {couponData?.description ||
                    couponData?.terms ||
                    couponData?.howToRedeem ||
                    dealImage?.aboutBrand ? (
                    <button
                      onClick={() =>
                        setIsExpanded(isExpanded === index ? null : index)
                      }
                      className="view-details flex justify-between items-center w-full pl-2 pb-4 mb-2"
                    >
                      {translation?.viewDetails}
                      {isExpanded === index ? (
                        <i className="fa fa-angle-up mr-3"></i>
                      ) : (
                        <i className="fa fa-angle-down ml-2"></i>
                      )}
                    </button>
                  ) : (
                    ""
                  )}

                  {isExpanded === index && (
                    <div className="space-y-4 mt-4 pl-2">
                      <div
                        className="mx-3"
                        dangerouslySetInnerHTML={{
                          __html: couponData?.description,
                        }}
                      />

                      <div
                        className={`bg-white ${dealImage?.aboutBrand ? "about-condition" : ""
                          } `}
                      >
                        {couponData?.terms ? (
                          <div
                            className="flex items-center justify-between px-4 py-3 cursor-pointer"
                            onClick={() => handleClick("terms", couponData)}
                          >
                            <button
                              className="about-condition-span"
                              onClick={() => handleClick("terms", couponData)}
                            >
                              {translation?.termsAndConditions}
                            </button>
                            <span className="about-condition-arr">›</span>
                          </div>
                        ) : (
                          ""
                        )}
                        {dealImage?.aboutBrand ? (
                          <div
                            className={`flex items-center ${couponData?.terms ? "border-t" : ""
                              } justify-between px-4 py-3 cursor-pointer`}
                            onClick={() => handleClick("About")}
                          >
                            <span className="about-condition-span">
                              {translation?.about} {dealImage?.name}
                            </span>
                            <span
                              className="about-condition-arr"
                              onClick={() => handleClick("About")}
                            >
                              ›
                            </span>
                          </div>
                        ) : (
                          ""
                        )}
                      </div>
                    </div>
                  )}
                </div>
                {(couponData?.isStaccOffer !== true || (couponData?.isStaccOffer === true && login)) &&
                  <div className="px-6 mt-4">
                    {couponData?.cta ? (
                      <span className="flex claim-top-border"></span>
                    ) : (
                      ""
                    )}
                    <div className="py-4 flex justify-between items-center">
                      {couponData?.cta ? (
                        <button
                          className="coupon-claim px-4 py-2"
                          onClick={() => handleClaimNow(couponData)}
                        >
                          {translation?.claimNow}
                        </button>
                      ) : (
                        ""
                      )}
                    </div>
                  </div>}
              </div>
            );
          })}
        </div>
        {isModalOpen && (
          <WebTermsCondition
            coupon={coupon}
            closed={() => setIsModalOpen(false)}
            deal={dealImage}
            about={about}
          />
        )}
      </div>}

    </>
  );
};

export default CouponModal;
